module.exports = __webpack_public_path__ + "static/media/search.b053ed85.png";